import http from './ajax';

const API_URL = {
  Journals: '/api/Journals', //會刊清單
  JournalDetail: '/api/Journal', //會刊詳細
  HealthEducations: '/api/HealthEducations', //衛教清單
  HealthEducationDetail: '/api/HealthEducation', //衛教詳細
  Videos: '/api/Videos', //影片清單
  VideoDetail: '/api/Video', //會刊詳細
  ProcessList: '/api/ActivityProcessList', //  歷屆活動流程
  ProcessDetail: '/api/ActivityProcess' //  歷屆活動流程
};

class conferenceApi extends http {
  //投稿清單
  JournalList = async (params = {}) => {
    try {
      let url = `${API_URL.Journals}?page=${params.page}&count=${params.count}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('JournalList', err);
    }
  };

  getJournalList = (params = {}) => {
    return this.JournalList(params);
  };

  //投稿詳細
  JournalDetail = async (params = {}) => {
    try {
      let url = `${API_URL.JournalDetail}/${params.Id}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('JournalDetail', err);
    }
  };

  getJournalDetail = (params = {}) => {
    return this.JournalDetail(params);
  };

  //衛教清單
  HealthEducationList = async (params = {}) => {
    try {
      let url = `${API_URL.HealthEducations}?page=${params.page}&count=${params.count}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('HealthEducationList', err);
    }
  };
  getHealthEducationList = (params = {}) => {
    return this.HealthEducationList(params);
  };

  //衛教詳細
  HealthEducationDetail = async (params = {}) => {
    try {
      let url = `${API_URL.HealthEducationDetail}/${params.Id}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('HealthEducationDetail', err);
    }
  };

  getHealthEducationDetail = (params = {}) => {
    return this.HealthEducationDetail(params);
  };

  //影片清單
  VideoList = async (params = {}) => {
    try {
      let url = `${API_URL.Videos}?page=${params.page}&count=${params.count}&isPublic=${params.isPublic}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('VideoList', err);
    }
  };
  getVideoList = (params = {}) => {
    return this.VideoList(params);
  };

  //影片詳細
  VideoDetail = async (params = {}) => {
    try {
      let url = `${API_URL.VideoDetail}/${params.Id}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('VideoDetail', err);
    }
  };

  getVideoDetaill = (params = {}) => {
    return this.VideoDetail(params);
  };

  //歷屆活動流程清單
  ProcessList = async (params = {}) => {
    try {
      let url = `${API_URL.ProcessList}?page=${params.page}&count=${params.count}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('JournalList', err);
    }
  };

  getProcessList = (params = {}) => {
    return this.ProcessList(params);
  };

  //歷屆活動流程詳細
  ProcessDetail = async (params = {}) => {
    try {
      let url = `${API_URL.ProcessDetail}/${params.Id}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('JournalDetail', err);
    }
  };

  getProcessDetail = (params = {}) => {
    return this.ProcessDetail(params);
  };
}

export default new conferenceApi();



// WEBPACK FOOTER //
// ./src/service/conference.js